module.exports = __webpack_public_path__ + "static/media/asstAmerica.4bace103.svg";